import {
    BottomAlignIcon,
    HorizontalCenterAlignIcon,
    LeftAlignIcon,
    RightAlignIcon,
    TopAlignIcon,
    VerticalCenterAlignIcon,
} from "@/icons/widget-menu";

export const ALIGN_ICONS = {
    left: LeftAlignIcon,
    right: RightAlignIcon,
    top: TopAlignIcon,
    bottom: BottomAlignIcon,
    hCenters: HorizontalCenterAlignIcon,
    vCenters: VerticalCenterAlignIcon,
};
